import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button, Grid, Input, Table, Select, Container, Icon } from 'semantic-ui-react';
import ProjectStore from '../../../app/stores/projectStore';
import { RootStoreContext } from '../../../app/stores/rootStore';

interface IProps {
  projectId: string;
}

const WarehouseImportForm: React.FC<IProps> = ({ projectId }) => {
  const rootStore = useContext(RootStoreContext);
  const {closeModal} = rootStore.modalStore;
  const projectStore = useContext(ProjectStore);
  const {
    warehouselogList,
    createWarehouseLog,
    loadWarehouseLogs,
    loadProjectStocks,
    submitting
  } = projectStore;

  // useEffect(() => {
  //   loadTechnicians();
  //   loadCertificates();

  //   return () => {
  //     fileRegistry.clear();
  //   };
  // }, []);

  const handleSubmit = () => {
    createWarehouseLog(warehouselogList).then(() => 
    loadWarehouseLogs(projectId)).then(() => 
    loadProjectStocks(projectId)).then(() => 
    closeModal());
  };
  var i = 0;
  
  return (
    <Container fluid>
    <Button
          loading={submitting}
          floated='left'
          color='green'
          onClick={handleSubmit}
          content='Submit'
        />
        <Table celled>
          <Table.Header>
            <Table.Row>
            <Table.HeaderCell>No.</Table.HeaderCell>
              <Table.HeaderCell>Order No</Table.HeaderCell>
              <Table.HeaderCell>Part No</Table.HeaderCell>
              <Table.HeaderCell>Ordered Qty</Table.HeaderCell>
              <Table.HeaderCell>Comment</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {warehouselogList.map((warehouselog) => {
                i = i + 1;
                return     <Table.Row >
                <Table.Cell>{i}</Table.Cell>
                <Table.Cell>{warehouselog.orderNo}</Table.Cell>
                <Table.Cell>{warehouselog.partNo}</Table.Cell>
                <Table.Cell>{warehouselog.quantity}</Table.Cell>
                <Table.Cell>{warehouselog.remark}</Table.Cell>
                
              </Table.Row> 
             })}
          </Table.Body>
        </Table>
        </Container>
  );
};

export default WarehouseImportForm;
